<!-- Flag and Hide Buttons -->
<div class="d-flex justify-content-start gap-2 mb-3">
  <button
    type="button"
    class="btn btn-sm"
    [ngClass]="{'btn-danger': currentFlagId === 1, 'btn-outline-danger': currentFlagId !== 1}"
    (click)="setFlag(1)"
    title="Red Flag">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-flag-fill" viewBox="0 0 16 16">
      <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001"/>
    </svg>
  </button>
  <button
    type="button"
    class="btn btn-sm"
    [ngClass]="{'btn-warning': currentFlagId === 3, 'btn-outline-warning': currentFlagId !== 3}"
    (click)="setFlag(3)"
    title="Yellow Flag">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-flag-fill" viewBox="0 0 16 16">
      <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001"/>
    </svg>
  </button>
  <button
    type="button"
    class="btn btn-sm"
    [ngClass]="{'btn-success': currentFlagId === 2, 'btn-outline-success': currentFlagId !== 2}"
    (click)="setFlag(2)"
    title="Green Flag">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-flag-fill" viewBox="0 0 16 16">
      <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001"/>
    </svg>
  </button>
  <button
    type="button"
    class="btn btn-sm"
    [ngClass]="{'btn-dark': currentFlagId === null, 'btn-outline-dark': currentFlagId !== null}"
    (click)="setFlag(null)"
    title="No flag">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-flag" viewBox="0 0 16 16">
      <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21.294 21.294 0 0 0 3 1.846v5.95c.193-.058.42-.124.661-.191C4.461 7.36 5.475 7.5 6.5 7.5c.86 0 1.755.197 2.443.435C9.747 8.142 10.343 8.5 11.5 8.5c.65 0 1.595-.213 2.366-.467.215-.071.42-.143.634-.214V1.222z"/>
    </svg>
  </button>
  <button
    type="button"
    class="btn btn-sm"
    [ngClass]="{'btn-secondary': currentHide === 1, 'btn-outline-secondary': currentHide !== 1}"
    (click)="toggleHide()"
    title="Hide in next test">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
      <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588M5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
      <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  </button>
</div>

<!-- Tabs Navigation -->
<ul class="nav nav-tabs mb-3" role="tablist">
  <li class="nav-item" role="presentation">
    <button class="nav-link" [class.active]="activeTab === 'question'" (click)="selectTab('question')" type="button">
      Question
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button class="nav-link" [class.active]="activeTab === 'explanation'" (click)="selectTab('explanation')" type="button">
      Explanation
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button class="nav-link" [class.active]="activeTab === 'note'" [ngClass]="{'text-warning': hasNote}" (click)="selectTab('note')" type="button">
      My Notes <span *ngIf="hasNote" class="badge bg-warning text-dark ms-1">!</span>
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button class="nav-link" [class.active]="activeTab === 'exam'" (click)="selectTab('exam')" type="button">
      Exam Question
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button class="nav-link" [class.active]="activeTab === 'comments'" [ngClass]="{'text-info': hasComments}" (click)="selectTab('comments')" type="button">
      Comments <span *ngIf="hasComments" class="badge bg-info text-dark ms-1">{{ (commentsData && commentsData.length > 0) ? commentsData.length : (hasComments ? '!' : '') }}</span>
    </button>
  </li>
</ul>

<!-- Tab Content -->
<div *ngIf="activeTab === 'question'" class="tab-content">
  <ng-container *ngIf="hasInlineQuestion; else questionFromPool">
    <h6 class="the-question lh-base mb-4">
      <span class="image-container" [innerHTML]="inlineQuestionHtmlForDisplay"></span>
    </h6>
    <div *ngIf="inlineQuestionImageUrls.length > 0" class="question-figures mb-4">
      <div *ngFor="let url of inlineQuestionImageUrls" class="question-figure mb-4">
        <img [src]="url" alt="" class="img-fluid clickable-image" (click)="openImageOverlay(url)" />
      </div>
    </div>

    <div class="answer-list" *ngIf="inlineAnswerRows.length > 0">
      <div class="answer-row" *ngFor="let row of inlineAnswerRows">
        <div class="answer-option" [ngClass]="{'answer-option-correct': isCorrectIdx(row.idx)}">
          <span class="answer-letter">{{ answerLetter(row.idx) }}</span>
          <span class="answer-text" [innerHTML]="row.html"></span>
          <span *ngIf="isCorrectIdx(row.idx)" class="answer-correct-pill">Correct</span>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #questionFromPool>
    <app-question-pool-question-detail
      [questionId]="questionId"
      [examMode]="false"
      [examTimeLeft]="1"
      [readOnly]="readOnlyQuestion">
    </app-question-pool-question-detail>
  </ng-template>
</div>

<div *ngIf="activeTab === 'explanation'" class="tab-content tab-content-body">
  <div *ngIf="isLoadingExplanation" class="text-center py-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div *ngIf="!isLoadingExplanation && explanationData">
    <div *ngIf="explanationData.explanationHtml || (explanationData.explanationImageUrls && explanationData.explanationImageUrls.length > 0)">
      <div *ngIf="explanationData.explanationHtml" class="mb-4">
        <h5>Explanation</h5>
        <div class="explanation-html" [innerHTML]="explanationData.explanationHtml"></div>
      </div>
      <div *ngFor="let url of explanationData.explanationImageUrls || (explanationData.figureExplanation ? [explanationData.figureExplanation] : [])" class="mb-4">
        <img [src]="url" alt="Explanation figure" class="img-fluid clickable-image" (click)="openImageOverlay(url)" />
      </div>
    </div>
    <div *ngIf="!explanationData.explanationHtml && (!explanationData.explanationImageUrls || explanationData.explanationImageUrls.length === 0) && !explanationData.figureExplanation" class="text-muted">
      <p>No explanation available for this question.</p>
      <p><em>Note: If you have additional information about this question, you can add it in the Notes tab.</em></p>
    </div>
  </div>
</div>

<div *ngIf="activeTab === 'note'" class="tab-content tab-content-body">
  <div class="mb-3">
    <label for="questionNotes" class="form-label">Your Notes</label>
    <small class="form-text text-muted d-block mb-2">Add personal notes for this question. Notes are saved automatically.</small>
    <textarea
      class="form-control"
      id="questionNotes"
      rows="10"
      [(ngModel)]="questionNotes"
      (input)="onNotesInput()"
      [ngModelOptions]="{standalone: true}"
      placeholder="Enter your notes here..."></textarea>
  </div>
</div>

<div *ngIf="activeTab === 'exam'" class="tab-content">
  <div *ngIf="isLoadingExamState" class="text-center py-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div *ngIf="!isLoadingExamState">
    <h5>Official Exam Usage</h5>
    <div *ngIf="examStateData && examStateData.length > 0">
      <p class="text-muted mb-3">This question has been reported as used in the following official state exams:</p>
      <div class="list-group">
        <div *ngFor="let exam of examStateData" class="list-group-item">
          <div class="d-flex justify-content-between">
            <strong>{{ exam.country }}</strong>
            <span class="text-muted">{{ exam.date }}</span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!examStateData || examStateData.length === 0" class="text-muted">
      <p>This question has not been reported in any official state exams.</p>
    </div>
  </div>
</div>

<div *ngIf="activeTab === 'comments'" class="tab-content tab-content-body">
  <div *ngIf="isLoadingComments" class="text-center py-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div *ngIf="!isLoadingComments">
    <h5>Comments</h5>
    <p class="text-muted mb-3">Comments from other users about this question:</p>

    <div *ngIf="commentsData && commentsData.length > 0" class="comments-container mb-4">
      <div *ngFor="let comment of commentsData; let i = index" class="comment-item" [ngClass]="{'comment-left': i % 2 === 0, 'comment-right': i % 2 === 1}">
        <div class="comment-content">
          <div class="comment-header">
            <strong>{{ comment.username }}</strong>
            <small class="text-muted">{{ formatDate(comment.createdAt) }}</small>
          </div>
          <div class="comment-text">{{ comment.comment }}</div>
        </div>
      </div>
    </div>

    <div *ngIf="!commentsData || commentsData.length === 0" class="text-muted mb-4">
      <p>No comments yet. Be the first to comment!</p>
    </div>

    <div class="mt-5">
      <h6>Add a Comment</h6>
      <p class="text-muted small mb-3">
        <em>Please share comments that are of interest to the community, such as clarifications, additional context, or helpful insights about this question.</em>
      </p>
      <div class="mb-3">
        <textarea
          class="form-control"
          id="newComment"
          rows="4"
          [(ngModel)]="newComment"
          [ngModelOptions]="{standalone: true}"
          [disabled]="!canSubmitComment"
          placeholder="Enter your comment here..."></textarea>
        <div *ngIf="!canSubmitComment && commentsData && commentsData.length > 0" class="text-warning small mt-2">
          You cannot submit another comment until someone else has commented.
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button
          class="btn btn-primary"
          (click)="submitComment()"
          [disabled]="!newComment || newComment.trim().length === 0 || isSubmittingComment || !canSubmitComment">
          <span *ngIf="isSubmittingComment" class="spinner-border spinner-border-sm me-2"></span>
          Submit Comment
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Image overlay: click explanation image to view full size -->
<div *ngIf="imageOverlayUrl" class="image-overlay" (click)="closeImageOverlay()">
  <img [src]="imageOverlayUrl" alt="Full size" class="image-overlay-img" (click)="$event.stopPropagation()" />
</div>

<!-- Comment Confirmation Modal -->
<div *ngIf="showCommentConfirm" class="modal-overlay" (click)="cancelComment()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Submit Public Comment?</h5>
        <button type="button" class="btn-close" (click)="cancelComment()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to submit this comment publicly? Your comment will be visible to all users.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancelComment()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="confirmComment()">Submit Comment</button>
      </div>
    </div>
  </div>
</div>

